// ─────────────────────────────────────────────────────────────
//  Setup-Pakete = wiederverwendbare Vorlagen für Einmalzahlungen.
//
//  Liegen global unter salesgod-research/setupPackages/{id} und beschreiben,
//  WAS ihr zu welchem Preis verkauft (Setup, Beratung, Workshop …). Am Kunden
//  wird eine Vorlage nur als Startwert benutzt: die Einmalzahlung speichert
//  Preis, Text und Features als eigene Kopie. Ändert ihr später das Paket,
//  bleiben bereits verkaufte Positionen deshalb unverändert – sonst würde eine
//  Preisanpassung rückwirkend Rechnungen und Provisionen verschieben.
// ─────────────────────────────────────────────────────────────

const SETUP_PACKAGES_PATH = 'salesgod-research/setupPackages';

const MAX_FEATURES = 12;
const MAX_LABEL = 120;
const MAX_FEATURE = 120;
const MAX_DESCRIPTION = 500;

// Firebase liefert Listen je nach Schlüsseln mal als Array, mal als Objekt.
const toFeatureList = (raw) => {
  if (!raw) return [];
  const src = Array.isArray(raw) ? raw : Object.keys(raw).sort().map((k) => raw[k]);
  return src
    .map((f) => (typeof f === 'string' ? f.trim() : ''))
    .filter(Boolean)
    .slice(0, MAX_FEATURES)
    .map((f) => f.slice(0, MAX_FEATURE));
};

function normalizePackage(id, raw) {
  if (!id || !raw || typeof raw !== 'object') return null;
  const label = typeof raw.label === 'string' ? raw.label.trim() : '';
  if (!label) return null;
  const amount = Number(raw.amount);
  return {
    id,
    label: label.slice(0, MAX_LABEL),
    amount: isFinite(amount) && amount > 0 ? Math.round(amount) : 0,
    description: typeof raw.description === 'string' ? raw.description.trim().slice(0, MAX_DESCRIPTION) : '',
    features: toFeatureList(raw.features),
    active: raw.active !== false,
    createdAt: Number(raw.createdAt) || 0,
    updatedAt: Number(raw.updatedAt) || 0,
  };
}

// Alle Pakete in Anlagereihenfolge. `activeOnly` blendet ausrangierte Pakete
// aus – die bleiben erhalten, tauchen aber nicht mehr in der Schnellauswahl auf.
function packageList(raw, activeOnly = false) {
  if (!raw || typeof raw !== 'object') return [];
  return Object.keys(raw)
    .map((id) => normalizePackage(id, raw[id]))
    .filter((p) => p && (!activeOnly || p.active))
    .sort((a, b) => (a.createdAt || 0) - (b.createdAt || 0));
}

const newPackageId = () => `sp${Date.now().toString(36)}${Math.random().toString(36).slice(2, 5)}`;

export {
  SETUP_PACKAGES_PATH,
  MAX_FEATURES,
  MAX_LABEL,
  MAX_FEATURE,
  MAX_DESCRIPTION,
  normalizePackage,
  packageList,
  newPackageId,
};
